import { Link, useNavigate } from 'react-router-dom';
import { useAppData } from '../AppData.js';
import { api } from '../api/client.js';
import { ShareStockButton } from '../components/ShareStockButton.js';
import { StockSearch } from '../components/StockSearch.js';
import { EmptyState, ExpiryBadge, storageEmoji, useAsync, useToast } from '../components/ui.js';

/** Home: grade de dispensas + o que esta vencendo + botao de escanear. */
export function HomePage() {
  const { storages, settings, ready, refresh } = useAppData();
  const navigate = useNavigate();
  const toast = useToast();
  const alerts = useAsync(() => api.listAlerts(), [storages.length]);

  async function createStorage() {
    const name = window.prompt('Nome da nova dispensa (ex.: Geladeira):');
    if (!name?.trim()) return;
    try {
      await api.createStorage({ name: name.trim(), icon: 'box', color: '#2f80ed' });
      await refresh();
      toast('Dispensa criada.', 'ok');
    } catch (error) {
      toast((error as Error).message, 'error');
    }
  }

  return (
    <main className="page">
      <div className="page-head">
        <h1>Minhas dispensas</h1>
        <div className="spacer" />
        {storages.length > 0 ? <ShareStockButton storages={storages} /> : null}
        <Link className="btn" to="/sem-codigo" title="Hortifruti, granel, feira">
          🥬 Sem codigo
        </Link>
        <button type="button" className="btn" onClick={createStorage}>
          + Nova dispensa
        </button>
      </div>

      {storages.length > 0 ? <StockSearch /> : null}

      {storages.length === 0 && ready ? (
        <EmptyState
          icon="🏠"
          title="Nenhuma dispensa ainda"
          hint="Crie a primeira (Geladeira, Despensa, Banheiro…) para comecar a guardar itens."
        />
      ) : (
        <div className="grid">
          {storages.map((storage) => (
            <Link
              key={storage.id}
              to={`/dispensa/${storage.id}`}
              className="storage-card"
              style={{ ['--accent' as string]: storage.color }}
            >
              <span className="icon">{storageEmoji(storage.icon)}</span>
              <span className="name">{storage.name}</span>
              <span className="meta">
                <span className="badge">
                  {storage.itemCount} {storage.itemCount === 1 ? 'item' : 'itens'}
                </span>
                {storage.expiredCount > 0 ? (
                  <span className="badge badge-danger">{storage.expiredCount} vencido(s)</span>
                ) : null}
                {storage.expiringCount > 0 ? (
                  <span className="badge badge-warn">{storage.expiringCount} vencendo</span>
                ) : null}
              </span>
            </Link>
          ))}
        </div>
      )}

      <section style={{ marginTop: 32 }}>
        <h2 style={{ fontSize: 20 }}>
          Vencendo em ate {settings.expiryAlertDays}{' '}
          {settings.expiryAlertDays === 1 ? 'dia' : 'dias'}
        </h2>
        {alerts.loading ? <p className="muted">Carregando…</p> : null}
        {!alerts.loading && (alerts.data?.length ?? 0) === 0 ? (
          <p className="muted">Nada vencendo por enquanto. 👌</p>
        ) : null}
        <ul className="list">
          {(alerts.data ?? []).map((item) => (
            <li key={item.id} className="item">
              <div className="photo">
                {item.product.photoUrl ? (
                  <img
                    src={item.product.photoUrl}
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }}
                  />
                ) : (
                  '🥫'
                )}
              </div>
              <div className="info">
                <div className="title">{item.product.name}</div>
                <div className="sub">
                  <ExpiryBadge item={item} />
                  <span>
                    {storageEmoji(item.storage.icon)} {item.storage.name}
                  </span>
                </div>
              </div>
              <div className="actions">
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => navigate(`/dispensa/${item.storage.id}`)}
                >
                  Abrir dispensa
                </button>
              </div>
            </li>
          ))}
        </ul>
      </section>

      <Link to="/escanear" className="btn btn-primary fab">
        📷 Escanear entrada
      </Link>
    </main>
  );
}
